export default "__VITE_ASSET__BBU$$_oi__"